import { LiaTimesCircleSolid } from "react-icons/lia";

export const TimesCircle = ({ ...rest }) => {
  return <LiaTimesCircleSolid {...rest} />;
};
